<template>
  <b-row>
    <b-col md="12">
      <b-card class="create-campaign">
        <validation-observer ref="templateidRules" tag="form">
          <b-row>
            <!-- User ID -->
            <b-col md="12">
              <b-form-group label="User ID" label-for="method">
                <validation-provider
                  #default="{ errors }"
                  name="userid"
                  rules="required"
                >
                  <v-select
                    id="userid"
                    v-model="formTemplate.userid"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="userTemplateID"
                    :reduce="(text) => text.id"
                    label="username"
                    placeholder="User ID"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End User ID -->

            <!-- SMS Template -->
            <b-col md="12">
              <b-form-group label-for="template-id" label="Template ID">
                <validation-provider
                  #default="{ errors }"
                  name="templateid"
                  rules="required"
                >
                  <b-form-input
                    id="template-id"
                    v-model="formTemplate.templateid"
                    placeholder="Template ID"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End SMS Template -->

            <!-- Sender -->
            <b-col md="12">
              <b-form-group label-for="sender" label="Sender">
                <validation-provider
                  #default="{ errors }"
                  name="sender"
                  rules="required"
                >
                  <b-form-input
                    id="sender"
                    v-model="formTemplate.sender"
                    placeholder="Sender"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Sender -->

            <!-- Client ID -->
            <b-col md="12">
              <b-form-group label-for="client-id" label="Client ID">
                <validation-provider
                  #default="{ errors }"
                  name="clientid"
                  rules="required"
                >
                  <b-form-input
                    id="client-id"
                    v-model="formTemplate.clientid"
                    placeholder="Client ID"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- End Client ID -->
          </b-row>
          <b-row>
            <b-col md="12" class="d-flex justify-content-end">
              <b-button
                v-on:click="backManageTemplate"
                class="backButton mr-2"
              >
                Back
                <feather-icon icon="RefreshIcon" size="22" />
              </b-button>
              <b-button
                v-on:click="formResetFormsTemplateID"
                class="resetCampaignButton mr-2"
              >
                Reset
                <feather-icon icon="RefreshIcon" size="22" />
              </b-button>
              <b-button v-on:click="formSubmittedTemplateID" class="submitCampaignButton">
                Submit
              </b-button>
            </b-col>
          </b-row>
        </validation-observer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BFormDatepicker,
  BFormRadio,
  BInputGroupText,
  BCard,
  BButton,
  BFormFile,
} from 'bootstrap-vue'

// Import V-Select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

import SmsBroadcast from '@/views/page/campaign/formContents/SmsBroadcast.vue'
import FlashMessage from '@/views/page/campaign/formContents/FlashMessage.vue'
import UssdContent from '@/views/page/campaign/formContents/UssdContent.vue'
import DigitalAds from '@/views/page/campaign/formContents/DigitalAds.vue'
import CampaignType from '@/views/page/campaign/formContents/CampaignType.vue'
import TargetAudience from '@/views/page/campaign/formContents/TargetAudience.vue'
import Ibn from '@/views/page/campaign/formContents/Ibn.vue'
import Bima from '@/views/page/campaign/formContents/Bima.vue'

import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'This is required!',
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BInputGroup,
    BFormDatepicker,
    BFormRadio,
    BInputGroupText,
    BCard,
    BButton,
    BFormFile,
    FlashMessage,
    CampaignType,
    TargetAudience,
    SmsBroadcast,
    UssdContent,
    DigitalAds,
    Bima,
    Ibn,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      isSubmited: false,
    }
  },
  computed: {
    ...mapGetters('datas', {
      channel: 'getChannel',
      methodBuy: 'getBuyMethod',
      templateID: 'getDataTemplateID',
    }),
    ...mapGetters('campaign', {
      campaignForm: 'getCampaignForm',
      statusDSV: 'getStatusDataDsv',
      formTemplate: 'getFormTemplate',
      userTemplateID: 'getUserTemplateID'
    }),
  },
  beforeMount() {
  },
  mounted() {
    // this.internal =
    this.dataTemplateID()
    this.setPlaceHolder()
    this.setTemplateUserID()
  },
  beforeDestroy() {
    this.resetFormTemplateID()
  },
  methods: {
    ...mapActions('campaign', ['resetFormTemplateID', 'createTemplateID', 'setTemplateUserID']),
    // SET LOCATION SEGMENTS
    ...mapActions('datas', [
      'dataTemplateID',
    ]),

    // SET PLACE HOLDER
    setPlaceHolder() {
      let txt = ''
      if (this.selectedCapping === 'by impression') {
        txt = 'Total Impressions'
      } else if (this.selectedCapping === 'by click') {
        txt = 'Total Clicks'
      } else if (this.selectedCapping === 'by sales') {
        txt = 'Total Sales'
      }
      return txt
    },

    // SET NAME
    setName(items, id) {
      const data = items.find((item) => item.value === id)
      return data.text
    },
    // END SET NAME

    // HANDLE SUBMIT
    formSubmittedTemplateID() {
      this.$refs.templateidRules.validate().then((res) => {
        if(res === true) {
          this.createTemplateID(this.formTemplate).then((response) => {
            if (response.status) {
              this.isSubmited = false
              this.success()
            } else {
              this.isSubmited = false
              this.failed(response)
            }
          })
          // console.log(this.formTemplate, "LSKDLSKDLSKDSKD");
        }
      })
    },
    buildFormData(formData, data, parentKey) {
      if (
        data &&
        typeof data === 'object' &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          )
        })
      } else {
        const value = data == null ? '' : data
        formData.append(parentKey, value)
      }
    },
    jsonToFormData(data) {
      const formData = new FormData()
      this.buildFormData(formData, data)
      return formData
    },
    success() {
      this.$swal({
        title: 'Registered Template ID success!',
        text:
          'Create template id success',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: 'manage-template' })
        }
      })
    },
    failed(type) {
      // console.log(type, 'types')
      let title = ''
      let text = ''
      // switch (type.status) {
      //   case 1:
      //     title = 'Your credit balance is not enough.'
      //     text = 'Please TOP UP to buy this channel and run your campaign.'
      //     break
      //   case 2:
      //     title = 'Sorry, channel schedule prices has been updated.'
      //     text = 'Please update your bid price on Choose Channel window.'
      //     break
      //   case 3:
      //     text = type.message
      //     break
      //   default:
      //     break
      // }
      let matchWord = type.message.match(/ConstraintViolationException/);
      if (type.status === false && matchWord[0] === "ConstraintViolationException") {
        title = 'Template Duplicate.'
      }else {
        title = 'Template cannot be registered!'
      }
      // const title = (type === 1) ? 'Your credit balance is not enough.' : 'Sorry, channel schedule prices has been updated.'
      // const text = (type === 1) ? 'Please TOP UP to buy this channel and run your campaign.' : 'Please update your bid price on Choose Channel window.'
      this.$swal({
        title,
        text,
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          switch (type.status) {
            case 1:
              this.$router.push({ name: 'topup-credit' })
              break
            case 2:
              this.$refs.wizard.changeTab(2, 0)
              break
            default:
              // this.$refs.wizard.changeTab(3, 0)
              break
          }
        }
      })
    },
    // END HANDLE SUBMIT

    // HANDLE RESET
    formResetFormsTemplateID() {
      this.resetFormTemplateID();
    },
    // END HANDLE RESET

    backManageTemplate() {
      const routeName = this.$route.matched[0].path
      this.$router.push({ path: `${routeName}/manage-template` })
    }
  },
}
</script>
<style scoped>
.submitCampaignButton {
  font-weight: bold;
  background: #32bcad !important;
  border: none;
}
.submitCampaignButton:hover {
  box-shadow: 0 8px 25px -8px #16a191 !important;
}
.backButton {
  font-weight: bold;
  background: #ffffff !important;
  color: #444444 !important;
  border: 1ps solid #3c9cc9;
}
.resetCampaignButton {
  font-weight: bold;
  background: #ffffff !important;
  color: #444444 !important;
  border: 1ps solid #444444;
}
</style>
